import React from 'react';
import PropTypes from 'prop-types';
import { ArrowBack } from '@one-thd/sui-icons';
import { ListItem,
  ListItemButton,
  ListItemText } from '@one-thd/sui-atomic-components';
import { NestedLinkRefinement } from './NestedLinkRefinement';
import { getInitialItemsToShowCount } from '../../../utils/showMoreLessUtility';

const LinkRefinement = ({
  arrow,
  dimension,
  id,
  onChange,
  refinement,
  hasBoldStyle,
  refinementIndex
}) => {

  const handleRefinementSelect = (event) => {
    event.preventDefault();
    if (onChange) {
      onChange({ refinement, dimension });
    }
  };

  const refinements = dimension?.refinements;
  const initialItemsToShowCount = getInitialItemsToShowCount(dimension, refinements);
  const isLastRefinement = refinementIndex === refinements.length - 1;
  const isNestedRefUndefinedSpecial = !refinement.nestedRefinements
    && refinements.length > initialItemsToShowCount && isLastRefinement;

  return (
    <>
      {/* SEO-friendly hidden link - Required for SEO significance. Reach out to SEO team if wanting to change */}
      <a
        href={refinement.url}
        className="sui-hidden"
        aria-hidden="true"
        tabIndex="-1"
      >
        {/* H3 element required for SEO significance. Reach out to SEO team if wanting to change */}
        <h3>{refinement.label}</h3>
      </a>
      {refinement.nestedRefinements && (
        <ListItem
          id={id}
          data-refinement={refinement.label}
          data-filterposition="left rail:top filters:1"
          data-active="yes"
          data-omni="true"
        >
          <ListItemButton
            data-testid={`${refinement.label}-${id}`}
            role="button"
            disableGutters
            aria-label={`Filter by ${refinement.label}`}
            data-refinementvalue={refinement.label}
            onClick={handleRefinementSelect}
          >
            {arrow && (
              <div className="sui-mt-1 sui-mr-2">
                <ArrowBack size="small" color="primary" />
              </div>
            )}
            <ListItemText
              primary={refinement.label}
              primaryTypographyProps={{
                weight: hasBoldStyle ? 'bold' : 'regular'
              }}
            />
          </ListItemButton>
        </ListItem>
      )}
      { (refinement?.nestedRefinements?.length > 0 || (isNestedRefUndefinedSpecial)) && (
        <NestedLinkRefinement
          id={id}
          dimension={dimension}
          refinement={refinement}
        />
      )}
    </>
  );
};

LinkRefinement.propTypes = {
  arrow: PropTypes.bool,
  dimension: PropTypes.shape({
    dimensionId: PropTypes.string,
    label: PropTypes.string,
    refinements: PropTypes.arrayOf(
      PropTypes.shape({})
    ),
    nestedRefinementsLimit: PropTypes.number
  }).isRequired,
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  refinement: PropTypes.shape({
    label: PropTypes.string,
    refinementKey: PropTypes.string,
    selected: PropTypes.bool,
    nestedRefinements: PropTypes.arrayOf(
      PropTypes.shape({
        length: PropTypes.number
      })
    ),
    url: PropTypes.string
  }).isRequired,
  hasBoldStyle: PropTypes.bool,
  refinementIndex: PropTypes.number
};

LinkRefinement.defaultProps = {
  arrow: false,
  id: null,
  hasBoldStyle: false,
  refinementIndex: 0
};

LinkRefinement.displayName = 'LinkRefinement';

export { LinkRefinement };
